<p-toast></p-toast>

<!-- Navigation Header -->
<div class="viewer-header flex align-items-center justify-content-between px-4 py-3 bg-white shadow-1 border-bottom-1 surface-border">
  <div class="flex align-items-center gap-2">
    <p-button
      icon="pi pi-arrow-left"
      [outlined]="true"
      severity="secondary"
      size="small"
      (click)="goBackToFiles()"
      pTooltip="Back to Files"
      tooltipPosition="bottom">
    </p-button>

    <span class="text-xl font-semibold" *ngIf="currentFile">
      {{ currentFile.fileName || currentFile.fileFullName }}
    </span>
  </div>
</div>

<!-- WebViewer Container -->
<div class="viewer-container">
  <div #viewer class="webviewer-wrapper"></div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
    <p class="mt-3">Loading document...</p>
  </div>
</div>
